import { createEvent, restore } from 'effector';
import { KEYCLOAK_CLIENTID } from 'shared/config';
import Keycloak, { type KeycloakInitOptions } from 'keycloak-js';

const keycloak = new Keycloak({
  url: `https://bkk.itlabs.io/auth`,
  realm: 'product-office',
  clientId: KEYCLOAK_CLIENTID,
});

const setIsAuthenticated = createEvent<boolean>();
export const $isAuthenticated = restore(setIsAuthenticated, false);

const setToken = createEvent<string | null>();
export const $token = restore(setToken, null);

const updateToken = async () => {
  try {
    const refreshed = await keycloak.updateToken(30);
    if (refreshed) {
      setToken(keycloak.token || null);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Ошибка при обновлении токена:', err);
    logout();
  }
};

let updateTokenInterval: number;

keycloak.onAuthSuccess = () => {
  updateTokenInterval = window.setInterval(updateToken, 30000);
  setToken(keycloak.idToken || null);
  setIsAuthenticated(true);
};

keycloak.onTokenExpired = () => {
  updateToken();
};

keycloak.onAuthError = (err: unknown) => {
  console.error('Ошибка авторизации:', err);
};

const initOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
};

keycloak
  .init(initOptions)
  .then((authenticated) => {
    setIsAuthenticated(authenticated);
    setToken(keycloak.idToken || null);

    if (authenticated) {
      // eslint-disable-next-line no-console
      console.log('Пользователь авторизован.');

      updateTokenInterval = window.setInterval(updateToken, 30000);
    } else {
      // eslint-disable-next-line no-console
      console.warn('Пользователь не авторизован.');
    }
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error('Ошибка инициализации Keycloak:', err);
  });

export const logout = () => {
  clearInterval(updateTokenInterval);
  setToken(null);
  setIsAuthenticated(false);

  keycloak.logout().catch((err) => {
    // eslint-disable-next-line no-console
    console.error('Ошибка при выходе:', err);
  });
};
